import React from 'react'
import MapUILocationTile from "./map-ui-location-tile";
import { fetchPlace } from '../../../../../modules/google-maps'
import { parseAddress, prepareQuery } from '../../../../../lib/google';
import PlacesSearch from "./places-search";

function MapUiOverlay({ location, reviewMarkers, updateLocation, updateField }) {
  const search = prepareQuery(location);

  const overlayStyle = {
    position: 'absolute',
    top: '0px',
    left: '0px',
    backgroundColor: 'white',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '20px',
    height: '100%',
    boxShadow: '5px 0 5px -5px rgba(0,0,0,0.2)',
    width: '400px',
    overflowY: 'scroll',
    zIndex: 1000,
  };

  function selectPlace(placeId) {
    fetchPlace(placeId)
      .then((data) => {
        const { name, geometry } = data;
        const address = parseAddress(data.address_components)
        const formatted = data.formatted_address.split(",")[0]

        updateLocation({
          ...location,
          places_response: {
            places: location.places_response.places,
            place: data
          },
          name: name,
          display_name: name,
          google_place_id: placeId,
          google_place_url: data.url,
          address: formatted,
          latitude: data.geometry.location.lat,
          longitude: data.geometry.location.lng,
          address_line_1: address.address_line_1,
          address_line_2: address.address_line_2,
          city: address.city,
          county: address.county,
          country: address.country,
          zipcode: address.postal_code
        })
      })
  }

  return (
    <div style={overlayStyle}>
      <MapUILocationTile
        name={location.name}
        address={location.address}
        city={location.city}
        state_code={location.state_code}
        zipcode={location.zipcode}
        lat={location.latitude}
        lng={location.longitude}
        borderClass={'border-l-4 border-l-teal-500'}
      />

      <PlacesSearch updateField={updateField} location={location} initSearch={search} />

      { reviewMarkers.length > 0 && (
        <div className='mt-3 py-2 px-3 bg-yellow-100'>
          Total Results: {reviewMarkers.length}
        </div>
      )}

      { reviewMarkers.map((marker, index) => {
        return (
          <MapUILocationTile
            key={`ui-tile-${index}`}
            name={marker.name}
            address={marker.address}
            city={marker.city}
            state_code={marker.state_code}
            zipcode={marker.zipcode}
            lat={marker.position.lat}
            lng={marker.position.lng}
            borderClass={'border-l-4 border-l-yellow-500'}
          >
            <button
              type="button"
              className="mt-1 rounded bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-500 shadow-sm hover:text-slate-600 hover:bg-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-300"
              onClick={(e) => {
                e.preventDefault()
                selectPlace(marker.placeId);
              }}
            >
              Select Place
            </button>
          </MapUILocationTile>
        )
      })}
    </div>
  );
};

export default MapUiOverlay;